module.exports = __webpack_public_path__ + "media/images/bg/shapes/ecru/3-020522fbf4d8d9bd8327aa37f29e0b37.svg";